import homeInactive from "@/assets/images/home-index.png"
import homeActive from "@/assets/images/home-index-hover.png"
import classifyInactive from "@/assets/images/home-classify.png"
import classifyActive from "@/assets/images/home-classify-hover.png"
import serviceInactive from "@/assets/images/home-service.png"
import serviceActive from "@/assets/images/home-service-hover.png"
import mineInactive from "@/assets/images/home-mine.png"
import mineActive from "@/assets/images/home-mine-hover.png"

const tabbarIcon = {
    homeInactive,
    homeActive,
    classifyInactive,
    classifyActive,
    serviceInactive,
    serviceActive,
    mineInactive,
    mineActive
}
export default tabbarIcon